import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'z-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {
  @Input() viewBox: string;
  @Input() width: string;
  @Input() height: string;
}
